<template>
  <div>
    <label
      v-if="label"
      class="vs-input--label"
    >{{ label }}</label> <br v-if="label" />
    <flat-pickr
      :config="configdateTimePicker"
      v-model="date"
      :placeholder="placeholder"
    />
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object | Date,
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      configdateTimePicker: {
        enableTime: false
      }
    }
  },
  computed: {
    date: {
      get () {
        return this.formatDateFlatpickr(this.data)
      },
      set (val) {
        this.$emit('change', new Date(val))
      }
    }
  }
}
</script>
